<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <fiscal-years-select
            :fiscalYears="form.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- RADIO TAX MODE -->
        <el-form-item
            :label="$t.__('common.actions.select_tax_display')"
            class="mb-4"
            prop="taxMode"
        >
            <CompassRadioGroup v-model="form.taxMode" direction="vertical">
                <CompassRadio modelValue="exc" :label="$l10n.__('HT')" />
                <CompassRadio modelValue="inc" :label="$l10n.__('TTC')" />
            </CompassRadioGroup>
        </el-form-item>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    components: {
        'fiscal-years-select': FiscalYearsSelect,
    },
    mixins: [SettingsFormMixin],
    data() {
        return {
            unreconciledRules: {
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    mounted() {
        this.$emit('set-rules', this.unreconciledRules);
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
};
</script>
